import axios from "axios";
import router from "@/router/index";
import auth from "@/utils/auth";
// import "babel-polyfill";
// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // api的base_url
    timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        let token = auth.getToken();
        if (token) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers["token"] = `${token}`;
        } else {
            config.headers["token"] = "";
        }
        return config;
    },
    error => {
        // // 对响应数据做点什么
        // //alert(JSON.stringify(response));
        if (response.data.code == 10000) {
            auth.removeToken();
            router.replace("/login");
            return Promise.reject(response.data);
        } else {
            return response.data;
        }
    }
);

// respone interceptor
service.interceptors.response.use(
    function(response) {
        // // 对响应数据做点什么
        // //alert(JSON.stringify(response));
        if (response.data.code == 10000) {
            auth.removeToken();
            router.replace("/login");
            return Promise.reject(response.data);
        } else {
            return response.data;
        }
    },
    function(error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);
service.defaults.withCredentials = true; //意思是携带cookie信息,保持session的一致性
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js